import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Cookies from 'js-cookie';
import { BASE_URL } from '../config/constants';
function MyLearning() {
	const [myCourses, setMyCourses] = useState([]);
	const token = Cookies.get('token');
	const baseUrl = BASE_URL;
	useEffect(() => {
		const getMyCourse = async () => {
			if (!token) {
				console.error('No token found. Please log in.');
				return;
			}

			try {
				const response = await fetch(`${baseUrl}/api/v1/my-learning/me`, {
					method: 'GET',
					headers: {
						'Content-Type': 'application/json',
						Authorization: `Bearer ${token}`,
					},
				});
				const data = await response.json();
				if (response.ok) {
					setMyCourses(data);
				}
			} catch (error) {
				console.log(error);
			}
		};

		getMyCourse();
	}, [token]);

	return (
		<main>
			<section className='bg-main h-[35vh] mt-4 md:h-[40vh] flex justify-center items-center mb-16'>
				<h2 className='text-2xl md:text-5xl text-white font-semibold'>
					My Learning
				</h2>
			</section>

			<section className='containerOfCourses gap-4 container grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 my-16'>
				{myCourses.length > 0 ? (
					myCourses.map((element) => (
						<Link
							to={`/my-learning/${element.course.id}`}
							className='courseContainer flex md:flex-col gap-4 border-[1px] border-solid overflow-hidden rounded-lg shadow-lg'
							key={element.id}>
							<div className='imagecontainer w-1/2 h-36  md:w-full '>
								<img
									loading='lazy'
									src={`${baseUrl}/${element.course.photo.path}`}
									alt={`${element.course.name} course`}
									className='w-full h-full object-cover md:object-cover'
								/>
							</div>
							<div className='courseText p-2 flex flex-col justify-center gap-2 mb-0 md:mb-4'>
								<div className='text-main text-lg font-semibold md:hover:text-secondary transition-all duration-200'>
									{element.course.name}
								</div>
								<p className='text-textColor text-sm'>{element.course.name}</p>
								<div className='rangeParent w-full h-0.5 bg-slate-300'>
									<div
										className={`rangeChild h-full bg-main`}
										style={{ width: `${element.id}%` }}></div>
								</div>
								<p className='text-textColor text-sm'>{element.id}%</p>
							</div>
						</Link>
					))
				) : (
					<div className='text-center col-span-1 md:col-span-2 lg:col-span-4 text-gray-600 text-lg'>
						You are not enrolled in any courses yet. Start exploring and enroll
						in courses to begin learning!
					</div>
				)}
			</section>
		</main>
	);
}

export default MyLearning;
